import { ChangeEvent } from 'react';
import { layout } from '../../NewHire/v2/styles';
import { SELF_REFLECTION_PROMPTS } from '../utils/questionsCatalog';

interface SelfReflectionStepProps {
  values: Record<string, string>;
  onChange: (key: string, value: string) => void;
}

const SelfReflectionStep = ({ values, onChange }: SelfReflectionStepProps) => {
  return (
    <div>
      <h2 style={{ ...layout.title, marginBottom: 4 }}>Employee Self-Reflection</h2>
      <p style={layout.subtitle as any}>Take a moment to reflect on the past year.</p>

      <div style={{ marginTop: 20 }}>
        {SELF_REFLECTION_PROMPTS.map((prompt) => (
          <div key={prompt.key} style={{ marginBottom: 18 }}>
            <label style={layout.label as any}>{prompt.label}</label>
            <textarea
              value={values[prompt.key] || ''}
              onChange={(e: ChangeEvent<HTMLTextAreaElement>) => onChange(prompt.key, e.target.value)}
              rows={4}
              style={{ ...(layout.input as any), resize: 'vertical', fontFamily: 'inherit' }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default SelfReflectionStep;
